module.exports = __webpack_public_path__ + "img/buy_super_ko.8ebc793a.png";